import * as React from "react";

import { cn } from "../lib/utils";

interface SpinnerWithTextProps {
  text?: string;
  variant?: "page" | "inline";
  className?: string;
}

function SpinnerWithText({
  text = "Loading...",
  variant = "inline",
  className,
}: SpinnerWithTextProps): React.JSX.Element {
  return (
    <div
      className={cn(
        "flex items-center justify-center self-stretch py-10",
        variant === "page" && "h-[60vh]",
        className,
      )}
    >
      <div className="flex flex-col items-center justify-start gap-4">
        <div className="relative h-8 w-8">
          <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="animate-spin"
          >
            <path
              d="M30 16.5C30 18.3385 29.6379 20.159 28.9343 21.8576C28.2308 23.5561 27.1995 25.0995 25.8995 26.3995C24.5995 27.6995 23.0561 28.7307 21.3576 29.4343C19.659 30.1379 17.8385 30.5 16 30.5C14.1615 30.5 12.341 30.1379 10.6424 29.4343C8.94387 28.7307 7.40052 27.6995 6.1005 26.3995C4.80048 25.0995 3.76925 23.5561 3.06569 21.8576C2.36212 20.159 2 18.3385 2 16.5C2 14.6615 2.36212 12.841 3.06569 11.1424C3.76926 9.44387 4.80049 7.90052 6.10051 6.6005C7.40053 5.30048 8.94388 4.26925 10.6424 3.56568C12.341 2.86212 14.1615 2.5 16 2.5C17.8385 2.5 19.659 2.86212 21.3576 3.56569C23.0561 4.26925 24.5995 5.30049 25.8995 6.60051C27.1995 7.90053 28.2308 9.44388 28.9343 11.1424C29.6379 12.841 30 14.6615 30 16.5L30 16.5Z"
              stroke="#F5F6F9"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 2.5C17.8385 2.5 19.659 2.86212 21.3576 3.56569C23.0561 4.26925 24.5995 5.30049 25.8995 6.60051C27.1995 7.90053 28.2308 9.44388 28.9343 11.1424C29.6379 12.841 30 14.6615 30 16.5"
              stroke="#155DFC"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {text && (
          <div className="text-center text-sm leading-tight font-medium text-slate-700">
            {text}
          </div>
        )}
      </div>
    </div>
  );
}

export { SpinnerWithText };
